import {createSlice} from '@reduxjs/toolkit'

const initialEventState = {
  event: null,
  eventsDropdown: null,
}

export const EventSlices = createSlice({
  name: 'events',
  initialState: initialEventState,
  reducers: {
    event: (state, action) => {
      state.event = action.payload.event
    },
    eventsList: (state, action) => {
      state.eventsDropdown = action.payload.events
    },
  },
})